import presenterRepo from '../services/presenters';

export const PRESENTERS_REFRESHED               = 'PRESENTERS_REFRESHED';
export const SHOW_DELETE_PRESENTER_OVERLAY      = 'SHOW_DELETE_PRESENTER_OVERLAY';
export const HIDE_DELETE_PRESENTER_OVERLAY      = 'HIDE_DELETE_PRESENTER_OVERLAY';
export const SHOW_EDIT_PRESENTER_OVERLAY        = 'SHOW_EDIT_PRESENTER_OVERLAY';
export const HIDE_EDIT_PRESENTER_OVERLAY        = 'HIDE_EDIT_PRESENTER_OVERLAY';
export const SHOW_ADD_PRESENTER_OVERLAY         = 'SHOW_ADD_PRESENTER_OVERLAY';
export const HIDE_ADD_PRESENTER_OVERLAY         = 'HIDE_ADD_PRESENTER_OVERLAY';
export const CHANGE_PICTURE_OF_PRESENTER        = 'CHANGE_PICTURE_OF_PRESENTER';
export const SHOW_DELETE_PICTURE_OVERLAY        = 'SHOW_DELETE_PICTURE_OVERLAY';
export const HIDE_DELETE_PICTURE_OVERLAY        = 'HIDE_DELETE_PICTURE_OVERLAY';
export const UPDATE_PRESENTER_SEARCH_RESULTS    = 'UPDATE_PRESENTER_SEARCH_RESULTS';

export function deletePresenterPicture(presenterId) {
    
    return (dispatch) => {

        function deleteSuccess() {

            dispatch(hideDeletePictureOverlay());
            dispatch(refreshPresenters());
        }
        
        presenterRepo.deletePicture(presenterId)
            .then(deleteSuccess);
    };
}

export function hideDeletePictureOverlay() {

    return {
        type: HIDE_DELETE_PICTURE_OVERLAY
    };
}

export function showDeleteProfilePictureOverlay(presenter) {

    return {
        type: SHOW_DELETE_PICTURE_OVERLAY,
        presenter
    };
}

export function changePictureOfPresenter(presenter) {

    return {
        type: CHANGE_PICTURE_OF_PRESENTER,
        presenter
    };
}

export function uploadProfilePicture(presenterId, file) {

    return (dispatch) => {

        function uploadSuccess() {

            dispatch(refreshPresenters());
        }

        presenterRepo.uploadProfilePicture(presenterId, file)
            .then(uploadSuccess);
    };
}

export function showAddPresenterOverlay() {

    return {
        type: SHOW_ADD_PRESENTER_OVERLAY
    };
}

export function hideAddPresenterOverlay() {

    return {
        type: HIDE_ADD_PRESENTER_OVERLAY
    };
}

export function showEditPresenterOverlay(presenter) {

    return {
        type: SHOW_EDIT_PRESENTER_OVERLAY,
        presenter
    };
}

export function hideEditPresenterOverlay() {

    return {
        type: HIDE_EDIT_PRESENTER_OVERLAY
    };
}

export function deletePresenter(presenterId) {

    return (dispatch) => {

        function removeSuccess() {

            dispatch(hideDeletePresenterOverlay());
            dispatch(refreshPresenters());
        }

        presenterRepo.remove(presenterId)
            .then(removeSuccess)
    };
}

export function showDeletePresenterOverlay(presenter) {

    return {
        type: SHOW_DELETE_PRESENTER_OVERLAY,
        presenter
    };
}

export function hideDeletePresenterOverlay() {

    return {
        type: HIDE_DELETE_PRESENTER_OVERLAY
    };
}

export function refreshPresenters() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(presentersRefreshed(response.data.data));
        }

        presenterRepo.getAll()
            .then(getSuccess);
    };
}

export function presentersRefreshed(presenters) {

    return {
        type: PRESENTERS_REFRESHED,
        presenters
    }
}

export function updatePresenterSearchResults(searchResults){
    return {
        type: UPDATE_PRESENTER_SEARCH_RESULTS,
        searchResults
    }
}

export function searchPresenters(searchTerm){
    const params = {
        searchTerm: searchTerm
    }

    return dispatch => {
        function getSuccess(response){
            dispatch(updatePresenterSearchResults(response.data.data));
        }

        presenterRepo.searchPresenters(params)
            .then(getSuccess);
    }
}


// WEBPACK FOOTER //
// ./actions/presenterList.js